// extracted by mini-css-extract-plugin
export var avatarContainer = "_13-0";
export var avatarTypingWave = "_13-i";
export var gray = "_13-f";
export var green = "_13-c";
export var icon = "_13-9";
export var image = "_13-1";
export var lg = "_13-6";
export var md = "_13-5";
export var presenceDot = "_13-b";
export var red = "_13-d";
export var sm = "_13-4";
export var status = "_13-a";
export var typingDot = "_13-h";
export var typingPill = "_13-g";
export var xl = "_13-7";
export var xs = "_13-3";
export var xxl = "_13-8";
export var xxs = "_13-2";
export var yellow = "_13-e";